import {Link, useLocation, useParams} from 'react-router-dom'
import {usersAPI} from '../../../services/UsersService'
import {DateRangePickerLr} from '../helpers/DateRangePickerLr'
import {LrFilter} from './LrFilter'
import {useState} from 'react'
import {KTSVG} from '../../../template/helpers'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

const LrHeader = () => {
  const {appId} = useParams()
  const location = useLocation()
  const {data: currentUser} = usersAPI.useFetchGetMeQuery()
  const [linkCdr] = useState<string>(location.pathname.includes('/management') ? '/management/cdr' : '/cdr')

  return (
    <div className='card-header border-1'>
      <div className='d-flex align-items-center gap-2 mt-2 w-100'>
        <div className='d-flex align-items-center gap-2'>
          <div className='w-290px'>
            <DateRangePickerLr
              language={currentUser?.language}
              timeZone={currentUser?.time_zone}
              rangeId='1'
              onlyIcon={false}
            />
          </div>
          <LrFilter />
        </div>
        <div className='ms-auto'>
          <OverlayTrigger
            delay={{show: 50, hide: 50}}
            overlay={
              <Tooltip id='tooltip-title' style={{position: 'fixed'}}>
                Перейти к журналу звонков
              </Tooltip>
            }
          >
            <Link to={`${linkCdr}/${appId}`}>
              <span className='badge badge-light-success cursor-pointer'>
                <KTSVG path='/media/icons/duotune/files/fil002.svg' className='svg-icon-success' />
              </span>
            </Link>
          </OverlayTrigger>
        </div>
      </div>
    </div>
  )
}

export {LrHeader}
